import { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function LibraryEleve() {
  const [loans, setLoans] = useState([]);
  const [studentId, setStudentId] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!studentId) return;
    api.get(`/library/my-loans/${studentId}`).then(setLoans).catch((e) => setError(e.message));
  }, [studentId]);

  return (
    <div className="panel">
      <div className="panel-head"><h2>Mes emprunts</h2></div>
      <div className="panel-body">
        <div className="field" style={{ marginBottom: 14 }}>
          <label>Je suis l'élève</label>
          <input type="text" placeholder="Saisir votre ID ou matricule" value={studentId} onChange={(e) => setStudentId(e.target.value)} />
        </div>
        {error && <div className="form-error">{error}</div>}
        {!studentId ? <div className="empty">Saisissez votre identifiant.</div> : loans.length === 0 ? <div className="empty">Vous n'avez pas d'emprunts.</div> : (
          <div className="table-wrap"><table>
            <thead><tr><th>Ouvrage</th><th>Emprunt</th><th>Retour prévu</th><th>Statut</th></tr></thead>
            <tbody>{loans.map((l) => {
              const isOverdue = l.daysOverdue > 0;
              return (
                <tr key={l.id} style={{ background: isOverdue ? '#fee2e2' : 'transparent' }}>
                  <td><b>{l.title}</b><br /><small>{l.author}</small></td>
                  <td className="mono">{new Date(l.loan_date).toLocaleDateString('fr-FR')}</td>
                  <td className="mono" style={{ color: isOverdue ? 'red' : 'green', fontWeight: isOverdue ? 700 : 'normal' }}>
                    {new Date(l.due_date).toLocaleDateString('fr-FR')} {isOverdue && `(+${l.daysOverdue}j en retard)`}
                  </td>
                  <td>{l.status === 'EN_COURS' ? <span className="badge navy">Emprunté</span> : <span className="badge green">Retourné</span>}</td>
                </tr>
              );
            })}</tbody>
          </table></div>
        )}
      </div>
    </div>
  );
}
